/**
 * Wrapper manager who provide user location
 */

import GpsInfos from "../GpsInfos";
import * as GpsInfosEnum from "../GpsInfos";
import Logger from "../../utils/Logger"

export default class GpsManagerWrapper {
    /**
     * Constructor
     *
     * @param {GpsManager} gpsManager The Gps manager
     * @param {ConfigGps} gpsConfiguration The configuration
     */
    constructor(gpsManager, gpsConfiguration) {
        /**
         * @type {GpsManager}
         */
        this.gpsManager = gpsManager;
        /**
         * @type {ConfigGps}
         */
        this.gpsConfiguration = gpsConfiguration;
    }

    /**
     * Return the last gps informations if not disabled by configuration
     *
     * @returns {GpsInfos} The GPS informations
     */
    get() {
        if (!this.gpsConfiguration || (this.gpsConfiguration && this.gpsConfiguration.enabled)) {
            return this.gpsManager.lastGpsInfos;
        } else {
            Logger.log("GPS coordinates disbale in scenario");
            return new GpsInfos(GpsInfosEnum.GPS_STATE_CAMPAIGN_DISABLED);
        }
    }

}


// WEBPACK FOOTER //
// ./js/core/gps/manager/GpsManagerWrapper.js